import React from 'react';

import FlexContainer from '@components/Gui/FlexContainer';
import NwDrawer from '@components/Gui/NwDrawer';
import PaymentPage from '@components/Payments/PaymentPage/PaymentPage';

//import { useNavigate } from 'react-router-dom';
// import styled from 'styled-components';
// import useNwBreakPoints from '@hooks/Layout/UseNwBreakPoints';
// import NwIcon from '@components/Gui/NwIcon';
// import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

// const Actions = styled(FlexContainer)`
//     svg {
//         margin-left: 8px;
//     }
// `;

const PaymentDrawer = ({ paymentID, contactType = 'model', onClose }) => {
    //const breakpoints = useNwBreakPoints();
    //const navigate = useNavigate();

    // const handleMoveModelPaymentDetails = () => {
    //     navigate(`/accounting-modelpayments/${paymentID}`);
    // };

    // Dynamic title based on contact type
    const getPaymentTitle = () => {
        switch (contactType.toLowerCase()) {
            case 'model':
                return 'Model Payment Details';
            case 'agency':
                return 'Agency Payment Details';
            case 'service':
                return 'Service Payment Details';
            default:
                return 'Payment Details';
        }
    };

    return (
        <NwDrawer
            width={'90vw'}
            padding="1rem"
            title={
                <FlexContainer justifyContent="space-between">
                    <div>{getPaymentTitle()}</div>
                    {/* {breakpoints > 3 && (
                        <Actions>
                            <NwIcon
                                icon={byPrefixAndName.fass['expand-wide']}
                                pointer
                                onClick={handleMoveModelPaymentDetails}
                                size="lg"
                            />
                        </Actions>
                    )} */}
                </FlexContainer>
            }
            onClose={onClose}
            whiteBg={false}
        >
            <PaymentPage paymentID={paymentID} contactType={contactType} onClose={onClose} inDrawer />
        </NwDrawer>
    );
};

export default PaymentDrawer;
